window.eventfilter = {
	update: function () {
		//rebuild chocies
		window.choices.rebuild();

		const eventFilterTabs = document.querySelectorAll('.m-event-filter__tabs [type="radio"]:checked');
		const eventFilterYear = document.querySelectorAll('[data-type="year"]');

		if ((eventFilterYear[0]) && (eventFilterTabs[0])) {
			if (eventFilterTabs[0].getAttribute('value') === '1') {
				//is archive
				eventFilterYear[0].classList.add('active')
			}
			else {
				eventFilterYear[0].classList.remove('active')
			}
		}
		else if ((eventFilterYear[0]) && (!eventFilterTabs[0])) {
			eventFilterYear[0].classList.add('active')
		}

		this.freetext()
	},

	freetext: function() {
		const elements = document.querySelectorAll('.m-event-filter__freetext__field input');

		if (!elements[0]) {
			return
		}

		for (let i = 0; i < elements.length; i++) {
			const element = elements[i];

			element.addEventListener('keyup', function(e) {
				const field = e.target
				const value = field.value;
				const base = field.closest('.m-event-filter__freetext')
				const label = base.querySelectorAll('label')

				if (value === '') {
					label[0].classList.remove('active');
				}
				else {
					label[0].classList.add('active');
				}

			}, false);
		}
	}
}

window.eventfilter.update();

jQuery(document).ready(function($) {
	$('#m-event-filter__reset_button button').on('click', function(e) {
		// Select
		$('.m-event-filter__select.m-event-filter__select--active').each(function() {
			$(this).removeClass('m-event-filter__select--active');
		});

		// Freetext
		$('.m-event-filter__freetext__wrapper').removeClass('m-event-filter__freetext--active');
	});

});
